export default __webpack_public_path__ + "static/media/logo_az_full.9fd78c53.png";